var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowRestore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 128H64C28.654 128 0 156.652 0 192V448C0 483.348 28.654 512 64 512H320C355.346 512 384 483.348 384 448V192C384 156.652 355.346 128 320 128ZM336 448C336 456.824 328.822 464 320 464H64C55.178 464 48 456.824 48 448V256H336V448ZM448 0H192C156.654 0 128 28.652 128 64V96H176V64C176 55.176 183.178 48 192 48H448C456.822 48 464 55.176 464 64V320C464 328.824 456.822 336 448 336H416V384H448C483.348 384 512 355.348 512 320V64C512 28.652 483.348 0 448 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowRestore);
export default __webpack_public_path__ + "static/media/window-restore.6b13a3a5d1dcae08b126e7108f188af3.svg";
export { ForwardRef as ReactComponent };